import cx from 'classnames'

import ChevronIcon from '../utility/chevron-icon'
import { type ImageSize } from './image-slide'

interface ArrowsProps {
  imageSize: ImageSize
  leftDisabled: boolean
  rightDisabled: boolean
  onLeftClick: () => void
  onRightClick: () => void
  className?: string
}

const Arrows = ({
  imageSize,
  leftDisabled,
  rightDisabled,
  onLeftClick,
  onRightClick,
  className,
}: ArrowsProps) => {
  const imageWidth = imageSize.width ?? 1200
  const imageMaxWidth =
    imageSize.width && imageSize.height
      ? (80 * imageSize.width) / imageSize.height
      : 0

  return (
    <div
      className={cx(
        'absolute top-0 left-0 hidden sm:flex w-full h-full justify-center items-center pointer-events-none z-10',
        className,
      )}
    >
      <div
        onClick={onLeftClick}
        className={cx(
          'flex-none flex justify-center items-center w-[100px] h-full text-white pointer-events-auto',
          {
            'opacity-70 cursor-pointer hover:opacity-100': !leftDisabled,
            'opacity-40 cursor-default': leftDisabled,
          },
        )}
      >
        <ChevronIcon direction="left" className="h-[18px]" />
      </div>

      <div
        className={`grow-0 shrink transition-all duration-200`}
        style={{
          flexBasis: `${imageWidth}px`,
          maxWidth: `${imageMaxWidth}vh`,
        }}
      />

      <div
        onClick={onRightClick}
        className={cx(
          'flex-none flex justify-center items-center w-[100px] h-full text-white pointer-events-auto',
          {
            'opacity-70 cursor-pointer hover:opacity-100': !rightDisabled,
            'opacity-40 cursor-default': rightDisabled,
          },
        )}
      >
        <ChevronIcon direction="right" className="h-[18px]" />
      </div>
    </div>
  )
}

export default Arrows
